import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchPlacements } from 'core/actions/ocapi';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import List from 'core/modules/Partials/List/List';
import MerchantTileListItem from 'core/modules/MerchantTileList/components/MerchantTileListItem/MerchantTileListItem';

import {
  selectTopEarnConfig, selectTopEarnIsLoading, selectTopEarnIsLoaded, selectTopEarnRecords,
} from './selectors';

import './TopEarn.scss';

export function TopEarn() {
  const config = useSelector(selectTopEarnConfig);
  const isLoading = useSelector(selectTopEarnIsLoading);
  const isLoaded = useSelector(selectTopEarnIsLoaded);
  const merchants = useSelector(selectTopEarnRecords);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      const { api: { params, options } } = config;
      dispatch(fetchPlacements(params, options));
    }
  }, []);

  if (isEmpty(merchants)) {
    return (null);
  }

  return (
    <div className="mn_topEarn">
      <ContentWrap>
        <SectionTitle title="Top earn rates" />
        <List>
          {merchants.map(merchant => (
            <MerchantTileListItem key={merchant.id} merchant={merchant} />
          ))}
        </List>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><TopEarn {...props} /></ComponentErrorBoundary>;
